import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProjectState {
  projectId: string | null;
}

const initialState: ProjectState = {
  projectId: null,
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProjectId: (state, action: PayloadAction<string | null>) => {
      state.projectId = action.payload;
    },
    clearProject: state => {
      state.projectId = null;
    },
  },
});

export const { setProjectId, clearProject } = projectSlice.actions;
export default projectSlice.reducer;

// Selectors
export const selectCurrentProjectId = (state: { project: ProjectState }) => state.project.projectId;
